export const NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR =
  '--navigation-header-banner-height';

export const NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR =
  '--navigation-bottom-bar-height';

export const NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR =
  '--navigation-content-banner-height';

function writeHeight(cssVar: string, value: string): void {
  const { style } = document.documentElement;

  if (style.getPropertyValue(cssVar) === value) {
    return;
  }

  style.setProperty(cssVar, value);
}

export function setNavigationHeaderBannerHeight(heightPx: number): void {
  writeHeight(NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR, `${heightPx}px`);
}

export function resetNavigationHeaderBannerHeight(): void {
  writeHeight(NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR, '0px');
}

export function setNavigationBottomBarHeight(heightPx: number): void {
  writeHeight(NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR, `${heightPx}px`);
}

export function resetNavigationBottomBarHeight(): void {
  writeHeight(NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR, '0px');
}

export function setNavigationContentBannerHeight(heightPx: number): void {
  writeHeight(NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR, `${heightPx}px`);
}

export function resetNavigationContentBannerHeight(): void {
  writeHeight(NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR, '0px');
}

export function viewportHeight(offset?: string): string {
  const base = `100vh - var(${NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR}, 0px) - var(${NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR}, 0px) - var(${NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR}, 0px)`;

  return offset ? `calc(${base} - ${offset})` : `calc(${base})`;
}
